import { Badge, Table } from 'react-bootstrap';
import './MercurXBackofficeTransactionTable.scss';
import { connect } from 'react-redux';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
import { mainColors } from '../../helpers/colors';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { setAlertAction } from '../../store/alert/alertActions';
import {
  setBackofficeTransactionsSortDataAction,
  sortBackofficeTransactionsAction,
} from '../../store/bo_transaction/bo_transactionActions';
import useMercurxPagination from '../../hooks/useMercurxPagination';
import MercurXTablePagination from '../MercurXTablePagination/MercurXTablePagination';
import MercurXSortableHeader from '../MercurXSortableHeader/MercurXSortableHeader';
import {
  BACKOFFICETRANSACTIONS_SORT_KEYS,
  BACKOFFICETRANSACTIONS_SORT_TYPES,
} from '../../pages/BackofficeTransactions/backofficeTransactionsConstants';

function MercurXBackofficeTransactionTable(props) {
  const {
    backofficeTransactions,
    filteredBackofficeTransactions,
    backofficeTransactionsSortData,
    setBackofficeTransactionsSortData,
    sortBackofficeTransactions,
    setAlert,
  } = props;
  const sourceData = filteredBackofficeTransactions || backofficeTransactions || [];
  const {
    currentPage,
    totalPages,
    visiblePages,
    pagedData: renderedTransactions,
    rowOffset,
    isFirstPage,
    isLastPage,
    goToPage,
    goToFirstPage,
    goToPrevPage,
    goToNextPage,
    goToLastPage,
  } = useMercurxPagination(sourceData, 10, 5);

  function scrollToTransactionsContainer() {
    const backofficeTransactionsContainer =
      document.getElementById('backofficeTransactions-container');
    if (backofficeTransactionsContainer) {
      backofficeTransactionsContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handlePageChange = (page) => {
    goToPage(page);
    scrollToTransactionsContainer();
  };

  const handleFirstPage = () => {
    goToFirstPage();
    scrollToTransactionsContainer();
  };

  const handlePrevPage = () => {
    goToPrevPage();
    scrollToTransactionsContainer();
  };

  const handleNextPage = () => {
    goToNextPage();
    scrollToTransactionsContainer();
  };

  const handleLastPage = () => {
    goToLastPage();
    scrollToTransactionsContainer();
  };

  function formatDate(dateString) {
    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short'
    };
    const formattedDate = new Intl.DateTimeFormat('default', options).format(new Date(dateString));
    return formattedDate;
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        setAlert({
          title: 'Success!',
          text: 'Wallet Address Copied To Clipboard',
          variant: 'success',
          outTimeMS: 3000,
        });
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleSort = (sortKey, defaultSortType) => {
    const nextSortType = backofficeTransactionsSortData.sortKey === sortKey
      ? (backofficeTransactionsSortData.sortType === BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
        ? BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING
        : BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING)
      : defaultSortType;

    setBackofficeTransactionsSortData({
      sortKey,
      sortType: nextSortType,
    });
    sortBackofficeTransactions();
  };

  return (
    <>
      <Table className="backofficeTransactions-table-design" responsive hover borderless>
        <thead>
          <tr className="text-t-body-color text-fs-tag">
            <th>#</th>
            <th>
              <MercurXSortableHeader
                label="Contract Name"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.PROJECT_NAME
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.PROJECT_NAME,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Action"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.ACTION
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.ACTION,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Value"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TOKEN_COUNT
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TOKEN_COUNT,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="User Public Address"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.USER_PUBLIC_ADDRESS
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.USER_PUBLIC_ADDRESS,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Token Address"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TOKEN_ADDRESS
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TOKEN_ADDRESS,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Txn Hash"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TRANSACTION_HASH
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TRANSACTION_HASH,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Txn Date"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.CREATE_DATE
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.CREATE_DATE,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Status"
                isActive={
                  backofficeTransactionsSortData.sortKey ===
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TRANSACTION_STATUS
                }
                isAscending={
                  backofficeTransactionsSortData.sortType ===
                  BACKOFFICETRANSACTIONS_SORT_TYPES.ASCENDING
                }
                onClick={() => handleSort(
                  BACKOFFICETRANSACTIONS_SORT_KEYS.TRANSACTION_STATUS,
                  BACKOFFICETRANSACTIONS_SORT_TYPES.DESCENDING
                )}
              />
            </th>
          </tr>
        </thead>
        {renderedTransactions?.length ? (
          <tbody>
            {renderedTransactions.map((item, index) => (
              <tr
                className="text-t-head-color"
                key={item.transaction_hash || `${item.cdate}-${index}`}
              >
                <td>{rowOffset + index + 1}</td>
                <td>{item.project_name}</td>
                <td>{item.action}</td>
                <td>{item.token_count / (10 ** 9)}</td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-address-${index}`}>
                      {item.user_public_address}</Tooltip>}
                  >
                    <span
                      className="copyable-text"
                      onClick={() => copyToClipboard(item.user_public_address)}
                    >
                      {`${item.user_public_address.slice(0, 3)}...${
                        item.user_public_address.slice(-3)}`}
                    </span>
                  </OverlayTrigger>
                </td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-token-${index}`}>
                      {item.token_address}</Tooltip>}
                  >
                    <span
                      className="copyable-text"
                      onClick={() => copyToClipboard(item.token_address)}
                    >
                      {`${item.token_address.slice(0, 3)}...${
                        item.token_address.slice(-3)}`}
                    </span>
                  </OverlayTrigger>
                </td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-hash-${index}`}>
                      {item.transaction_hash}</Tooltip>}
                  >
                    <span
                      className="copyable-text"
                      onClick={() => copyToClipboard(item.transaction_hash)}
                    >
                      {`${item.transaction_hash.slice(0, 3)}...${
                        item.transaction_hash.slice(-3)}`}
                    </span>
                  </OverlayTrigger>
                </td>
                <td>{formatDate(item.cdate)}</td>
                <td>
                  {item.transaction_status ? (
                    <Badge bg="success">Success</Badge>
                  ) : (
                    <Badge bg="danger">Fail</Badge>
                  )}
                </td>
                <td>
                  <p className="border-bottom-detail mt-1">
                    <a
                      href={'https://testnet.bscscan.com/tx/' + item.transaction_hash}
                      target="_blank"
                      rel="noreferrer"
                      className="link"
                    >
                      <MercurXIcons
                        name="BsFillInfoSquareFill"
                        size={18}
                        color={mainColors.primary}
                      />
                    </a>
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </Table>
      {!renderedTransactions?.length && (
        <div className="d-flex text-fs-body-md text-t-body-color justify-content-center">
          No transaction found according to search results.
        </div>
      )}
      <MercurXTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        visiblePages={visiblePages}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        onFirstPage={handleFirstPage}
        onPrevPage={handlePrevPage}
        onPageChange={handlePageChange}
        onNextPage={handleNextPage}
        onLastPage={handleLastPage}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    backofficeTransactions: state.backofficeTransactionReducer.backofficeTransactions,
    filteredBackofficeTransactions:
      state.backofficeTransactionReducer.filteredBackofficeTransactions,
    backofficeTransactionsSortData:
      state.backofficeTransactionReducer.backofficeTransactionsSortData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBackofficeTransactionsSortData: (payload) => {
      dispatch(setBackofficeTransactionsSortDataAction(payload));
    },
    sortBackofficeTransactions: () => {
      dispatch(sortBackofficeTransactionsAction());
    },
    setAlert: (payload) => {
      dispatch(setAlertAction(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MercurXBackofficeTransactionTable);
